import type { FreeTier, Tier } from './types'

export const isPaidTier = (tier: Tier | FreeTier): tier is Tier => {
  return 'variants' in tier
}
